/**
 * KingZoo Wholesale App
 * Handles: CSV loading, product table render, shared cart (localStorage),
 *          Order Form, Quick Quote, My Quote pages + EmailJS quote submission.
 */
(function () {
  'use strict';

  // ── Config ────────────────────────────────────────────────────────────────
  // CSV_URL removed — data comes exclusively from metafield (kzCustomer.csvData)
  // This prevents unauthenticated access to wholesale pricing data
  var CART_KEY           = 'kz_wholesale_cart';
  var CSV_CACHE_KEY      = 'kz_wh_csv';
  var CSV_CACHE_TTL      = 3600000; // 1 hour

  var EMAILJS_PUBLIC_KEY = '5iuKAgBRnXLJdhBIf';
  var EMAILJS_SERVICE_ID = 'service_King';
  var EMAILJS_TPL_QUOTE  = 'QuoteRequest';
  var HISTORY_KEY        = 'kz_quote_history';

  // ── Customer data ─────────────────────────────────────────────────────────
  var dataEl        = document.getElementById('kz-wholesale-data');
  var customerTag   = dataEl ? (dataEl.dataset.customerTag || '').toUpperCase() : '';
  var customerEmail = dataEl ? dataEl.dataset.customerEmail : '';
  var customerName  = dataEl ? dataEl.dataset.customerName : '';
  var isEUR         = customerTag.indexOf('B2BEXP') !== -1;
  var kzLang        = (window.kzCustomer && window.kzCustomer.lang) || 'tr';
  var isTR          = kzLang === 'tr';
  // Email dili: müşteri etiketine göre — B2BTR → Türkçe, B2BEXP → İngilizce
  var isEmailTR     = customerTag.indexOf('B2BTR') !== -1;

  // ── Cart helpers ──────────────────────────────────────────────────────────
  function cartGet() {
    try { return JSON.parse(localStorage.getItem(CART_KEY)) || []; } catch(e) { return []; }
  }
  function cartSave(items) {
    try { localStorage.setItem(CART_KEY, JSON.stringify(items)); } catch(e) {}
    updateBadge();
  }
  function cartAdd(product, qty) {
    var items = cartGet();
    var idx = items.findIndex(function(i) { return i.product_id === product.product_id; });
    if (idx > -1) {
      items[idx].qty = Math.max(0, items[idx].qty + qty);
      if (items[idx].qty === 0) items.splice(idx, 1);
    } else if (qty > 0) {
      var item = Object.assign({}, product, { qty: qty });
      items.push(item);
    }
    cartSave(items);
    return items;
  }
  function cartSet(product, qty) {
    var productId = (typeof product === 'object') ? product.product_id : product;
    var items = cartGet();
    var idx = items.findIndex(function(i) { return i.product_id === productId; });
    if (qty <= 0) {
      if (idx > -1) items.splice(idx, 1);
    } else if (idx > -1) {
      items[idx].qty = qty;
    } else if (typeof product === 'object' && qty > 0) {
      // New product — save full object for My Quote to read
      items.push(Object.assign({}, product, { qty: qty }));
    }
    cartSave(items);
  }
  function cartQty(productId) {
    var item = cartGet().find(function(i) { return i.product_id === productId; });
    return item ? item.qty : 0;
  }
  function updateBadge() {
    var total = cartGet().reduce(function(s, i) { return s + i.qty; }, 0);
    var badge = document.getElementById('kz-mini-count');
    if (badge) badge.textContent = total + (isTR ? ' ürün seçildi' : (total === 1 ? ' item selected' : ' items selected'));
    var miniTotal = document.getElementById('kz-mini-total');
    if (miniTotal) miniTotal.textContent = formatTotal(cartGet());
  }

  // ── Price / format helpers ────────────────────────────────────────────────
  // ── HTML escape helper (XSS prevention) ───────────────────────────────
  function esc(s) {
    if (!s) return '';
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function roundHalf(x) { return Math.round(x * 2) / 2; }
  function fmtPrice(val, eur) {
    if (!val || val == 0) return '—';
    var n = parseFloat(val);
    if (eur) {
      var r = roundHalf(n);
      return '€' + r.toLocaleString('de-DE', { minimumFractionDigits: r % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
    }
    return '₺' + Math.round(n).toLocaleString('tr-TR');
  }
  // FX rate — TRY → EUR (kingzoo-currency-switcher.js ile aynı sabit)
  var KZ_FX_TRY_TO_EUR = 0.0195;

  function fmtDiscount(p) {
    var retail = retailPrice(p);
    var ws     = parseFloat(wholesalePrice(p));
    if (!retail || !ws || retail === 0) return '';
    var pct = Math.round((1 - ws / retail) * 100);
    return pct > 0 ? '-' + pct + '%' : '';
  }
  function wholesalePrice(p) {
    if (isEUR) {
      var eur = parseFloat(p.wholesale_eur) || 0;
      if (eur > 0) return eur;
      // Fallback: TRY varsa FX ile çevir
      var tr = parseFloat(p.wholesale_try) || 0;
      return tr > 0 ? (tr * KZ_FX_TRY_TO_EUR) : 0;
    }
    return parseFloat(p.wholesale_try) || 0;
  }
  function retailPrice(p) {
    if (isEUR) {
      var eur = parseFloat(p.retail_eur) || 0;
      if (eur > 0) return eur;
      // Fallback: TRY varsa FX ile çevir
      var tr = parseFloat(p.retail_try) || 0;
      return tr > 0 ? (tr * KZ_FX_TRY_TO_EUR) : 0;
    }
    return parseFloat(p.retail_try) || 0;
  }
  function formatTotal(items) {
    var sum = items.reduce(function(s, i) { return s + parseFloat(wholesalePrice(i) || 0) * i.qty; }, 0);
    if (sum === 0) return '';
    return isEUR ? fmtPrice(sum, true) : fmtPrice(sum, false);
  }

  // ── CSV loading ───────────────────────────────────────────────────────────
  function loadCSV(cb) {
    // 1. Inline data from metafield (fastest — no fetch needed)
    if (window.kzCustomer && window.kzCustomer.csvData) {
      var data = window.kzCustomer.csvData;
      try { localStorage.setItem(CSV_CACHE_KEY, JSON.stringify({ ts: Date.now(), data: data })); } catch(e) {}
      cb(data);
      return;
    }
    // 2. localStorage cache
    try {
      var cached = JSON.parse(localStorage.getItem(CSV_CACHE_KEY));
      if (cached && Date.now() - cached.ts < CSV_CACHE_TTL) { cb(cached.data); return; }
    } catch(e) {}
    // 3. No data available — not a wholesale customer or data not loaded
    console.warn('KZ Wholesale: no product data available (metafield missing or not a wholesale customer)');
    cb([]);
  }

  function splitCSVLine(line) {
    var result = [], cur = '', inQ = false;
    for (var i = 0; i < line.length; i++) {
      var c = line[i];
      if (c === '"') { inQ = !inQ; }
      else if (c === ',' && !inQ) { result.push(cur); cur = ''; }
      else { cur += c; }
    }
    result.push(cur);
    return result;
  }

  // ── 3 main categories (matches site nav; By Lifestyle removed) ───────────
  var MAIN_CATS = ['Tableware', 'Home Decor', 'Bathroom'];
  var MAIN_CATS_TR = { 'Tableware': 'Sofra', 'Home Decor': 'Ev Dekorasyonu', 'Bathroom': 'Banyo' };

  var MAIN_CAT = {
    'Sofra':                            'Tableware',
    'Kase & Meze Tabakları':            'Tableware',
    'Kase ve Meze Tabakları':           'Tableware',
    'Sofra Aksesuarları':               'Tableware',
    'Sunumluklar':                      'Tableware',
    'Servis Altlıkları':                'Tableware',
    'Fırın Pişirme Kapları':            'Tableware',
    'Mutfak':                           'Tableware',
    'Ev Dekorasyonu':                   'Home Decor',
    'Dekoratif Sepetler & Saksılar':    'Home Decor',
    'Masa Üstü':                        'Home Decor',
    'Evcil Hayvan Aksesuarları':        'Home Decor',
    'Mobilya':                          'Home Decor',
    'Salon':                            'Home Decor',
    'Çalışma Odası':                    'Home Decor',
    'Yatak Odası':                      'Home Decor',
    'Banyo':                            'Bathroom',
    'Banyo Aksesuarları':               'Bathroom',
    'Banyo Sepetleri & Düzenleyiciler': 'Bathroom',
  };

  // Sub-collection EN labels (shown in table Collection column)
  var COL_EN = {
    'Sofra':                               'Dining',
    'Kase & Meze Tabakları':               'Bowls & Mezze Plates',
    'Kase ve Meze Tabakları':              'Bowls & Mezze Plates',
    'Banyo':                               'Bathroom',
    'Ev Dekorasyonu':                      'Home Décor',
    'Sofra Aksesuarları':                  'Dining Accessories',
    'Banyo Aksesuarları':                  'Bathroom Accessories',
    'Sunumluklar':                         'Serving Platters',
    'Masa Üstü':                           'Tabletop',
    'Fırın Pişirme Kapları':               'Oven & Bakeware',
    'Banyo Sepetleri & Düzenleyiciler':    'Bathroom Baskets & Organizers',
    'Dekoratif Sepetler & Saksılar':       'Decorative Baskets & Planters',
    'Servis Altlıkları':                   'Serving Trivets',
    'Evcil Hayvan Aksesuarları':           'Pet Accessories',
    'Mobilya':                             'Furniture',
    'Mutfak':                              'Kitchen',
    'Salon':                               'Living Room',
    'Çalışma Odası':                       'Home Office',
    'Yatak Odası':                         'Bedroom'
  };
  function colEN(name) { return COL_EN[name] || name; }
  function mainCat(name) { return MAIN_CAT[name] || 'Home Decor'; }

  // ── Group + alphabetical sort (Tableware → Home Decor → Bathroom,
  //    sub-collection alphabetical, title alphabetical) ─────────────────────
  var MAIN_ORDER = { 'Tableware': 1, 'Home Decor': 2, 'Bathroom': 3 };
  function sortByGroupAndTitle(arr) {
    return arr.sort(function(a, b) {
      var mA = MAIN_ORDER[mainCat(a.collection || '')] || 99;
      var mB = MAIN_ORDER[mainCat(b.collection || '')] || 99;
      if (mA !== mB) return mA - mB;
      var subA = (a.collection || '').toLowerCase();
      var subB = (b.collection || '').toLowerCase();
      if (subA !== subB) return subA.localeCompare(subB, 'tr');
      var titleA = (a.title_tr || a.title_en || '').toLowerCase();
      var titleB = (b.title_tr || b.title_en || '').toLowerCase();
      return titleA.localeCompare(titleB, 'tr');
    });
  }

  // ── Collection filter buttons ─────────────────────────────────────────────
  // Color alias map for normalization
  var COLOR_ALIASES = {
    'medium brown': 'mat mid brown',
    'mid brown':    'mat mid brown',
    'honey brown':  'shine honey brown',
    'dark brown':   'mat dark brown',
    'whitewash':    'white wash',
    'white wash':   'white wash'
  };

  function normalizeColor(c) {
    var lower = (c || '').toLowerCase();
    return COLOR_ALIASES[lower] || lower;
  }

  function buildAllFilters(products) {
    var container = document.getElementById('kz-filters');
    if (!container) return;
    container.innerHTML = '';

    // Sub-category order (matches site menu hierarchy)
    var SUB_ORDER = {
      'Tableware':    ['Kase & Meze Tabakları', 'Kase ve Meze Tabakları', 'Sunumluklar', 'Fırın Pişirme Kapları', 'Sofra Aksesuarları'],
      'Home Decor':   ['Dekoratif Sepetler & Saksılar', 'Masa Üstü', 'Evcil Hayvan Aksesuarları', 'Mobilya'],
      'Bathroom':     ['Banyo Sepetleri & Düzenleyiciler', 'Banyo Aksesuarları']
    };

    // ── Inject [All] [Search] [All Colors] [Reset Filters] into toolbar ─────
    var searchEl = document.getElementById('kz-search');
    var toolbarEl = searchEl ? searchEl.parentNode : null;

    // Remove leftovers from previous renders
    if (toolbarEl) {
      ['kz-all-chip-toolbar', 'kz-color-filter', 'kz-reset-filters'].forEach(function(id) {
        var el = document.getElementById(id);
        if (el && el.parentNode === toolbarEl) toolbarEl.removeChild(el);
      });
    }

    // [All] chip — toolbar'da search input'tan ÖNCE
    var all = document.createElement('button');
    all.id = 'kz-all-chip-toolbar';
    all.className = 'kz-filter-btn active';
    all.type = 'button';
    all.dataset.col = '';
    all.textContent = isTR ? 'Tümü' : 'All';
    all.style.cssText = 'font-family:inherit;';

    // Color Filter dropdown (4 hardcoded)
    var colorSelect = document.createElement('select');
    colorSelect.id = 'kz-color-filter';
    colorSelect.style.cssText = 'width:160px;font-family:inherit;';
    colorSelect.innerHTML = '<option value="">' + (isTR ? 'Tüm Renkler' : 'All Colors') + '</option>';
    var hardcodedColors = ['White Wash', 'Mat Dark Brown', 'Mat Mid Brown', 'Shine Honey Brown'];
    hardcodedColors.forEach(function(c) {
      var opt = document.createElement('option');
      opt.value = normalizeColor(c);
      opt.textContent = c;
      colorSelect.appendChild(opt);
    });

    // Reset button
    var resetBtn = document.createElement('button');
    resetBtn.id = 'kz-reset-filters';
    resetBtn.type = 'button';
    resetBtn.style.cssText = 'border:none;background:none;color:#888;font-size:13px;font-style:normal;text-decoration:underline;cursor:pointer;height:38px;padding:0 8px;font-family:inherit;';
    resetBtn.textContent = isTR ? 'Filtreleri Sıfırla' : 'Reset Filters';
    resetBtn.addEventListener('click', function() {
      // All chip'leri pasif et, sonra "All" toolbar chip'ini aktive et
      document.querySelectorAll('.kz-filter-btn').forEach(function(b) { b.classList.remove('active'); });
      all.classList.add('active');
      colorSelect.value = '';
      var s = document.getElementById('kz-search');
      if (s) { s.value = ''; currentSearch = ''; }
      filterTable();
    });

    // Place: [All] | [Search] (mevcut) | [All Colors] | [Reset Filters]
    if (toolbarEl && searchEl) {
      // Önce All — search'ün önüne
      toolbarEl.insertBefore(all, searchEl);
      // Sonra Color + Reset — search'ün arkasına
      var afterSearch = searchEl.nextSibling;
      if (afterSearch) {
        toolbarEl.insertBefore(colorSelect, afterSearch);
        toolbarEl.insertBefore(resetBtn, colorSelect.nextSibling);
      } else {
        toolbarEl.appendChild(colorSelect);
        toolbarEl.appendChild(resetBtn);
      }
    }

    // ── Rows 2–4: category rows (her ana kategori ayrı satırda) ──────────
    var catOrder = [
      { main: 'Tableware', subs: ['Kase & Meze Tabakları', 'Sunumluklar', 'Fırın Pişirme Kapları', 'Sofra Aksesuarları'] },
      { main: 'Home Decor', subs: ['Dekoratif Sepetler & Saksılar', 'Masa Üstü', 'Evcil Hayvan Aksesuarları', 'Mobilya'] },
      { main: 'Bathroom', subs: ['Banyo Sepetleri & Düzenleyiciler', 'Banyo Aksesuarları'] }
    ];

    catOrder.forEach(function(catGroup) {
      var row = document.createElement('div');
      row.className = 'kz-filter-row';
      row.style.cssText = 'display:flex;gap:6px;flex-wrap:wrap;align-items:center;border-top:0.5px solid #f0f0f0;padding:6px 0;flex-basis:100%;width:100%;';

      // Main category chip (default white; .active CSS turns it black on click)
      var header = document.createElement('button');
      header.className = 'kz-filter-btn';
      header.dataset.col = catGroup.main;
      header.textContent = isTR ? (MAIN_CATS_TR[catGroup.main] || catGroup.main) : catGroup.main;
      header.style.cssText = 'font-family:inherit;font-weight:500;';
      row.appendChild(header);

      // Sub-category buttons
      catGroup.subs.forEach(function(sub) {
        var btn = document.createElement('button');
        btn.className = 'kz-filter-btn';
        btn.dataset.subcol = sub.toLowerCase();
        btn.textContent = isTR ? sub : (colEN(sub) || sub);
        btn.style.cssText = 'font-family:inherit;';
        row.appendChild(btn);
      });

      container.appendChild(row);
    });

    // ── Click handlers ────────────────────────────────────────────────────
    // All chip toolbar'da — direkt handler
    all.addEventListener('click', function() {
      document.querySelectorAll('.kz-filter-btn').forEach(function(b) { b.classList.remove('active'); });
      all.classList.add('active');
      filterTable();
    });

    // Kategori container'da — delegated (her chip için tüm chip'lerin active'ini temizle)
    container.addEventListener('click', function(e) {
      var btn = e.target.closest('.kz-filter-btn');
      if (!btn) return;
      document.querySelectorAll('.kz-filter-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      filterTable();
    });

    colorSelect.addEventListener('change', function() { filterTable(); });
  }

  function buildFilters(products) {
    // Only show 4 main categories that actually have products
    var usedMains = {};
    products.forEach(function(p) {
      if (p.collection) usedMains[mainCat(p.collection)] = true;
    });

    var container = document.getElementById('kz-filters');
    if (!container) return;
    container.innerHTML = '';

    // Category buttons
    var all = document.createElement('button');
    all.className = 'kz-filter-btn active';
    all.dataset.col = '';
    all.textContent = isTR ? 'Tümü' : 'All';
    container.appendChild(all);

    MAIN_CATS.forEach(function(cat) {
      if (!usedMains[cat]) return;
      var btn = document.createElement('button');
      btn.className = 'kz-filter-btn';
      btn.dataset.col = cat;
      btn.textContent = isTR ? (MAIN_CATS_TR[cat] || cat) : cat;
      container.appendChild(btn);
    });

    container.addEventListener('click', function(e) {
      var btn = e.target.closest('.kz-filter-btn');
      if (!btn) return;
      container.querySelectorAll('.kz-filter-btn').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      filterTable();
    });

    // Color dropdown (hardcoded 4 colors, same as Quick Quote)
    var colorSelect = document.createElement('select');
    colorSelect.id = 'kz-color-filter';
    colorSelect.style.cssText = 'width:160px;';
    colorSelect.innerHTML = '<option value="">' + (isTR ? 'Tüm Renkler' : 'All Colors') + '</option>';
    var hardcodedColors = ['White Wash', 'Mat Dark Brown', 'Mat Mid Brown', 'Shine Honey Brown'];
    hardcodedColors.forEach(function(c) {
      var opt = document.createElement('option');
      opt.value = normalizeColor(c);
      opt.textContent = c;
      colorSelect.appendChild(opt);
    });
    colorSelect.addEventListener('change', function() { filterTable(); });
    container.appendChild(colorSelect);

    // Reset button
    var resetBtn = document.createElement('button');
    resetBtn.className = 'kz-filter-btn';
    resetBtn.id = 'kz-reset-filters';
    resetBtn.textContent = isTR ? 'Filtreleri Sıfırla' : 'Reset Filters';
    resetBtn.style.cssText = 'border:none;background:none;color:#888;font-size:13px;font-style:normal;text-decoration:underline;cursor:pointer;height:38px;padding:0 8px;font-family:inherit;';
    resetBtn.addEventListener('click', function() {
      container.querySelectorAll('.kz-filter-btn').forEach(function(b) { b.classList.remove('active'); });
      all.classList.add('active');
      colorSelect.value = '';
      var searchEl = document.getElementById('kz-search');
      if (searchEl) { searchEl.value = ''; currentSearch = ''; }
      filterTable();
    });
    container.appendChild(resetBtn);
  }

  var currentSearch = '';
  function filterTable() {
    var activeBtn = document.querySelector('.kz-filter-btn.active');
    var ds = activeBtn ? activeBtn.dataset : {};
    var useSubcol = activeBtn && 'subcol' in ds;
    var col = useSubcol ? (ds.subcol || '') : (ds.col || '').toLowerCase();
    var colorEl = document.getElementById('kz-color-filter');
    var colorFilter = colorEl ? normalizeColor(colorEl.value) : '';
    var search = currentSearch.toLowerCase();
    var rows = document.querySelectorAll('#kz-tbody tr[data-id], #kz-tbody tr[data-pid]');
    rows.forEach(function(row) {
      // Selected items always visible
      if (row.dataset.selected === '1') { row.style.display = ''; return; }
      var rCol   = useSubcol ? (row.dataset.subcol || '') : (row.dataset.col || '').toLowerCase();
      var rColor = normalizeColor(row.dataset.color || '');
      var rText  = (row.dataset.text || '').toLowerCase();
      var show   = (!col || rCol === col)
                && (!colorFilter || rColor === colorFilter)
                && (!search || rText.indexOf(search) !== -1 || normalizeColor(rColor).indexOf(search) !== -1);
      row.style.display = show ? '' : 'none';
    });
  }

  // ── Product table row ─────────────────────────────────────────────────────
  function makeProductRow(p, qty, isSelected) {
    var wp    = wholesalePrice(p);
    var rp    = retailPrice(p);
    var disc  = fmtDiscount(p);
    var sub   = qty > 0 ? fmtPrice(parseFloat(wp) * qty, isEUR) : '—';
    var tr    = document.createElement('tr');
    tr.dataset.id   = p.product_id;
    tr.dataset.pid  = p.product_id;
    tr.dataset.col    = mainCat(p.collection || '');
    tr.dataset.subcol = (p.collection || '').toLowerCase();
    tr.dataset.color  = (p.color || '').toLowerCase();
    tr.dataset.text   = ((p.title_tr || '') + ' ' + (p.title_en || '') + ' ' + (p.collection || '') + ' ' + (p.sku || '') + ' ' + (p.color || '')).toLowerCase();

    tr.innerHTML =
      '<td class="kz-td-img"><a href="/products/' + esc(p.handle) + '" target="_blank"><img class="kz-prod-img" src="' + esc(p.image_url) + '" alt=""></a></td>' +
      '<td class="kz-td-product"><a href="/products/' + esc(p.handle) + '" target="_blank">' + esc(isTR ? (p.title_tr || p.title_en) : (p.title_en || p.title_tr)) + '</a></td>' +
      '<td class="kz-td-sku">' + esc(p.sku) + '</td>' +
      '<td class="kz-td-color">' + esc(p.color) + '</td>' +
      '<td class="kz-td-col">' + esc(p.collection ? (isTR ? p.collection : mainCat(p.collection)) : '') + '</td>' +
      '<td class="kz-td-mat">' + esc(isTR ? (p.material || p.material_en || '') : (p.material_en || p.material || '')) + '</td>' +
      '<td class="kz-td-size">' + esc(p.dimensions) + '</td>' +
      '<td class="kz-td-retail">' + fmtPrice(rp, isEUR) + '</td>' +
      '<td class="kz-td-ws">' + fmtPrice(wp, isEUR) + '</td>' +
      '<td class="kz-td-disc">' + disc + '</td>' +
      '<td class="kz-td-qty">' +
        '<div class="kz-qty-wrap">' +
          '<button class="kz-qty-btn" data-action="dec" aria-label="Decrease">&#8722;</button>' +
          '<input class="kz-qty-input" type="number" min="0" value="' + qty + '" data-pid="' + esc(p.product_id) + '" aria-label="Quantity">' +
          '<button class="kz-qty-btn" data-action="inc" aria-label="Increase">&#43;</button>' +
        '</div>' +
      '</td>' +
      '<td class="kz-subtotal-cell">' + sub + '</td>';

    // Qty input events
    var qtyInput = tr.querySelector('.kz-qty-input');
    tr.querySelector('[data-action="dec"]').addEventListener('click', function() {
      var v = Math.max(0, parseInt(qtyInput.value || 0) - 1);
      qtyInput.value = v;
      cartSet(p, v);
      updateRowSubtotal(tr, p, v);
      updateMiniCart();
    });
    tr.querySelector('[data-action="inc"]').addEventListener('click', function() {
      var v = parseInt(qtyInput.value || 0) + 1;
      qtyInput.value = v;
      cartSet(p, v);
      updateRowSubtotal(tr, p, v);
      updateMiniCart();
    });
    qtyInput.addEventListener('change', function() {
      var v = Math.max(0, parseInt(this.value) || 0);
      this.value = v;
      cartSet(p, v);
      updateRowSubtotal(tr, p, v);
      updateMiniCart();
    });


    return tr;
  }

  function updateRowSubtotal(tr, p, qty) {
    var cell = tr.querySelector('.kz-subtotal-cell');
    if (cell) cell.textContent = qty > 0 ? fmtPrice(parseFloat(wholesalePrice(p)) * qty, isEUR) : '—';
  }

  function updateMiniCart() {
    var items = cartGet();
    var total = items.reduce(function(s, i) { return s + i.qty; }, 0);
    var badge = document.getElementById('kz-mini-count');
    if (badge) badge.textContent = total + (isTR ? ' ürün seçildi' : (total === 1 ? ' item selected' : ' items selected'));
    var miniTotal = document.getElementById('kz-mini-total');
    if (miniTotal) miniTotal.textContent = formatTotal(items);
  }

  // ── Order Form page ───────────────────────────────────────────────────────
  function initOrderForm(products) {
    var tbody = document.getElementById('kz-tbody');
    if (!tbody) return;
    tbody.innerHTML = '';
    if (products.length === 0) {
      tbody.innerHTML = '<tr><td colspan="12" style="text-align:center;padding:40px;color:#c00;">' + (isTR ? 'Ürünler yüklenemedi. Lütfen sayfayı yenileyin.' : 'Failed to load products. Please refresh the page.') + '</td></tr>';
      return;
    }
    buildFilters(products);

    // Group + alphabetical sort: Tableware → Home Decor → Bathroom,
    // sub-collection a→z, then title a→z (so same-named products stack)
    sortByGroupAndTitle(products);

    products.forEach(function(p) {
      var qty = cartQty(p.product_id);
      tbody.appendChild(makeProductRow(p, qty, false));
    });

    var searchInput = document.getElementById('kz-search');
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        currentSearch = this.value;
        filterTable();
      });
    }
    updateMiniCart();
  }

  // ── Quick Quote row (stock-focused, no Retail/Discount) ────────────────
  function makeQuickQuoteRow(p, qty, onChange) {
    var wp    = wholesalePrice(p);
    var stock = parseInt(p.shopify_stock) || 0;
    var sub   = qty > 0 ? fmtPrice(parseFloat(wp) * qty, isEUR) : '—';
    var tr    = document.createElement('tr');
    tr.dataset.id   = p.product_id;
    tr.dataset.pid  = p.product_id;
    tr.dataset.col    = mainCat(p.collection || '');
    tr.dataset.subcol = (p.collection || '').toLowerCase();
    tr.dataset.color  = (p.color || '').toLowerCase();
    tr.dataset.text   = ((p.title_tr || '') + ' ' + (p.title_en || '') + ' ' + (p.collection || '') + ' ' + (p.sku || '') + ' ' + (p.color || '')).toLowerCase();

    var stockLabel = stock > 0 ? stock : (isTR ? 'Yok' : 'Out');

    var colorAndStock = esc(p.color) + ' <span class="kz-mobile-stock">(' + stockLabel + ')</span>';

    tr.innerHTML =
      '<td class="kz-td-img"><a href="/products/' + esc(p.handle) + '" target="_blank"><img class="kz-prod-img" src="' + esc(p.image_url) + '" alt=""></a></td>' +
      '<td class="kz-td-product"><a href="/products/' + esc(p.handle) + '" target="_blank">' + esc(isTR ? (p.title_tr || p.title_en) : (p.title_en || p.title_tr)) + '</a></td>' +
      '<td class="kz-td-sku">' + esc(p.sku) + '</td>' +
      '<td class="kz-td-color">' + colorAndStock + '</td>' +
      '<td class="kz-td-col">' + esc(p.collection ? (isTR ? p.collection : mainCat(p.collection)) : '') + '</td>' +
      '<td class="kz-td-mat">' + esc(isTR ? (p.material || p.material_en || '') : (p.material_en || p.material || '')) + '</td>' +
      '<td class="kz-td-size">' + esc(p.dimensions) + '</td>' +
      '<td class="kz-td-ws">' + fmtPrice(wp, isEUR) + '</td>' +
      '<td class="kz-td-stock" style="font-weight:600;">' + stockLabel + '</td>' +
      '<td class="kz-td-qty">' +
        '<div class="kz-qty-wrap">' +
          '<button class="kz-qty-btn" data-action="dec" aria-label="Decrease">&#8722;</button>' +
          '<input class="kz-qty-input" type="number" min="0" max="' + stock + '" value="' + qty + '" data-pid="' + esc(p.product_id) + '" aria-label="Quantity">' +
          '<button class="kz-qty-btn" data-action="inc" aria-label="Increase">&#43;</button>' +
        '</div>' +
      '</td>' +
      '<td class="kz-subtotal-cell">' + sub + '</td>';

    var qtyInput = tr.querySelector('.kz-qty-input');
    tr.querySelector('[data-action="dec"]').addEventListener('click', function() {
      var v = Math.max(0, parseInt(qtyInput.value || 0) - 1);
      qtyInput.value = v;
      cartSet(p, v);
      updateRowSubtotal(tr, p, v);
      updateMiniCart();
      if (onChange) onChange(tr, v);
    });
    tr.querySelector('[data-action="inc"]').addEventListener('click', function() {
      var v = parseInt(qtyInput.value || 0) + 1;
      if (v > stock) { v = stock; }
      qtyInput.value = v;
      cartSet(p, v);
      updateRowSubtotal(tr, p, v);
      updateMiniCart();
      if (onChange) onChange(tr, v);
    });
    qtyInput.addEventListener('change', function() {
      var v = Math.max(0, parseInt(this.value) || 0);
      if (v > stock) { v = stock; }
      this.value = v;
      cartSet(p, v);
      updateRowSubtotal(tr, p, v);
      updateMiniCart();
      if (onChange) onChange(tr, v);
    });

    return tr;
  }

  // ── Load Shopify stock ───────────────────────────────────────────────────
  // İki kaynak birleştiriliyor:
  //   1. window.kzCustomer.stockMap (theme.liquid'den server-side, gerçek qty)
  //      → shop.custom.wholesale_stock_data metafield'ından geliyor
  //      → shopify_stock_to_metafield.py admin API'den çekip yazıyor
  //   2. /products.json (storefront, available bool — qty güvenilmez)
  //      → variant.available kararı (purchasable mı?) için kullanılıyor
  // Sonuç: gerçek qty (1) + storefront available kararı (2)
  function loadStockMap(cb) {
    var serverStock = (window.kzCustomer && window.kzCustomer.stockMap) || {};
    fetch('/products.json?limit=250')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var map = {};
        (data.products || []).forEach(function(p) {
          var anyAvailable = false;
          (p.variants || []).forEach(function(v) {
            if (v.available) anyAvailable = true;
          });
          // Gerçek qty server-side metafield'dan, fallback olarak 0
          var realQty = parseInt(serverStock[p.handle]) || 0;
          map[p.handle] = {
            available: anyAvailable,
            qty:       realQty
          };
        });
        // serverStock'ta olup /products.json'da olmayan ürünleri de ekle
        Object.keys(serverStock).forEach(function(h) {
          if (!map[h]) {
            map[h] = { available: parseInt(serverStock[h]) > 0, qty: parseInt(serverStock[h]) || 0 };
          }
        });
        cb(map);
      })
      .catch(function() {
        // Storefront fail olursa sadece server stockMap kullan
        var map = {};
        Object.keys(serverStock).forEach(function(h) {
          map[h] = { available: parseInt(serverStock[h]) > 0, qty: parseInt(serverStock[h]) || 0 };
        });
        cb(map);
      });
  }

  // ── Quick Quote page ──────────────────────────────────────────────────────
  function initQuickQuote(products) {
    var tbody = document.getElementById('kz-tbody');
    if (!tbody) return;
    tbody.innerHTML = '';
    if (products.length === 0) {
      tbody.innerHTML = '<tr><td colspan="11" style="text-align:center;padding:40px;color:#c00;">' + (isTR ? 'Ürünler yüklenemedi. Lütfen sayfayı yenileyin.' : 'Failed to load products. Please refresh the page.') + '</td></tr>';
      return;
    }

    // products zaten loadAllProducts() içinde Shopify-driven (sku, handle, image,
    // shopify_available, shopify_stock + CSV meta) ile geliyor.
    // Burada artık ek loadStockMap fetch yok.
    buildAllFilters(products);

    // QQ filtresi: Shopify'da satılabilir (available=true) ürünler.
    // Sıralama: Tableware → Home Decor → Bathroom, sub-collection a→z, title a→z
    // (aynı isimli ürünler aynı kategori altında alt alta gelir)
    var inStock = products.filter(function(p) { return p.shopify_available; });
    sortByGroupAndTitle(inStock);

    var productMap = {};
    inStock.forEach(function(p) { productMap[p.product_id] = p; });

    var cartItems = cartGet();
    var selectedIds = cartItems.map(function(i) { return i.product_id; });

    // Promote-on-add: when a non-selected row gets qty>0, move it just above
    // the separator so newly added items collect at the top of the list.
    var separator = null;
    function promoteRow(tr, v) {
      if (v <= 0 || tr.dataset.selected === '1') return;
      tr.dataset.selected = '1';
      if (separator && separator.parentNode === tbody) {
        tbody.insertBefore(tr, separator);
        separator.style.display = '';
      } else {
        tbody.insertBefore(tr, tbody.firstChild);
      }
      tr.style.transition = 'opacity .35s ease-out';
      tr.style.opacity = '0.35';
      setTimeout(function() { tr.style.opacity = ''; }, 50);
    }

    cartItems.forEach(function(item) {
      var p = productMap[item.product_id];
      if (p) {
        var row = makeQuickQuoteRow(p, item.qty, promoteRow);
        row.dataset.selected = '1';
        tbody.appendChild(row);
      }
    });

    separator = document.createElement('tr');
    separator.id = 'kz-qq-separator';
    separator.innerHTML = '<td colspan="11" style="padding:6px 12px;background:#f8f8f8;font-size:12px;color:#999;font-style:italic;">' + (isTR ? '— Daha fazla ürün ekle —' : '— Add more products below —') + '</td>';
    if (cartItems.length === 0) separator.style.display = 'none';
    tbody.appendChild(separator);

    inStock.forEach(function(p) {
      if (selectedIds.indexOf(p.product_id) === -1) {
        tbody.appendChild(makeQuickQuoteRow(p, 0, promoteRow));
      }
    });

    var searchInput = document.getElementById('kz-search');
    if (searchInput) {
      searchInput.addEventListener('input', function() {
        currentSearch = this.value;
        filterTable();
      });
    }
    updateMiniCart();
  }

  // ── My Quote page ─────────────────────────────────────────────────────────
  function initMyQuote(products) {
    var productMap = {};
    products.forEach(function(p) { productMap[p.product_id] = p; });

    var cartItems = cartGet();
    var emptyEl   = document.getElementById('kz-quote-empty');
    var contentEl = document.getElementById('kz-quote-content');

    if (cartItems.length === 0) {
      if (emptyEl)   emptyEl.style.display = 'block';
      if (contentEl) contentEl.style.display = 'none';
      renderQuoteHistory();
      return;
    }

    if (emptyEl)   emptyEl.style.display = 'none';
    if (contentEl) contentEl.style.display = 'block';

    var tbody = document.getElementById('kz-quote-tbody');
    if (!tbody) return;
    tbody.innerHTML = '';

    // Sepetteki ürünleri kategori + alfabetik sırala (Order Form/QQ ile aynı kural)
    cartItems.sort(function(a, b) {
      var pa = productMap[a.product_id] || {};
      var pb = productMap[b.product_id] || {};
      var mA = MAIN_ORDER[mainCat(pa.collection || '')] || 99;
      var mB = MAIN_ORDER[mainCat(pb.collection || '')] || 99;
      if (mA !== mB) return mA - mB;
      var subA = (pa.collection || '').toLowerCase();
      var subB = (pb.collection || '').toLowerCase();
      if (subA !== subB) return subA.localeCompare(subB, 'tr');
      var titleA = (pa.title_tr || pa.title_en || '').toLowerCase();
      var titleB = (pb.title_tr || pb.title_en || '').toLowerCase();
      return titleA.localeCompare(titleB, 'tr');
    });

    cartItems.forEach(function(item) {
      var p = productMap[item.product_id];
      if (!p) return;
      var wp  = wholesalePrice(p);
      var sub = fmtPrice(parseFloat(wp) * item.qty, isEUR);
      var pTitle = isTR ? (p.title_tr || p.title_en) : (p.title_en || p.title_tr);
      var pMat   = isTR ? (p.material || p.material_en || '') : (p.material_en || p.material || '');
      var pCol   = isTR ? (p.collection || '') : mainCat(p.collection || '');
      var stock  = parseInt(p.shopify_stock) || 0;
      var qqOk   = stock > 0 && item.qty <= stock;
      var qqSym  = qqOk ? '□' : '○'; // □ boş kare = stokta + adet uyuyor; ○ yuvarlak = stokta yok / yetersiz
      var tr  = document.createElement('tr');
      tr.dataset.pid = p.product_id;
      tr.innerHTML =
        '<td><img src="' + esc(p.image_url) + '" alt="" style="width:48px;height:48px;object-fit:cover;border-radius:4px;"></td>' +
        '<td><strong>' + esc(pTitle) + '</strong></td>' +
        '<td class="kz-td-sku">' + esc(p.sku) + '</td>' +
        '<td class="kz-td-color">' + esc(p.color) + '</td>' +
        '<td class="kz-td-col">' + esc(pCol) + '</td>' +
        '<td class="kz-td-mat">' + esc(pMat) + '</td>' +
        '<td class="kz-td-size">' + esc(p.dimensions) + '</td>' +
        '<td style="font-weight:600;">' + fmtPrice(wp, isEUR) + '</td>' +
        '<td class="kz-td-qq" style="text-align:center;font-weight:700;font-size:16px;">' + qqSym + '</td>' +
        '<td>' +
          '<div class="kz-qty-wrap">' +
            '<button class="kz-qty-btn" data-action="dec" aria-label="Decrease">−</button>' +
            '<input class="kz-qty-input" type="number" min="0" value="' + item.qty + '" data-pid="' + esc(p.product_id) + '" aria-label="Quantity">' +
            '<button class="kz-qty-btn" data-action="inc" aria-label="Increase">+</button>' +
          '</div>' +
        '</td>' +
        '<td class="kz-subtotal-cell">' + sub + '</td>' +
        '<td><button class="kz-row-btn kz-btn-remove" data-pid="' + p.product_id + '" title="Remove">×</button></td>';

      var qtyInput = tr.querySelector('.kz-qty-input');
      var qqCell = tr.querySelector('.kz-td-qq');
      function refreshSub() {
        var v = parseInt(qtyInput.value) || 0;
        var cell = tr.querySelector('.kz-subtotal-cell');
        if (cell) cell.textContent = v > 0 ? fmtPrice(parseFloat(wp) * v, isEUR) : '—';
        if (qqCell) {
          var ok = stock > 0 && v <= stock;
          qqCell.innerHTML = ok ? '□' : '○';
        }
        cartSet(p, v);
        refreshGrandTotal(productMap);
      }
      tr.querySelector('[data-action="dec"]').addEventListener('click', function() {
        qtyInput.value = Math.max(0, parseInt(qtyInput.value || 0) - 1);
        refreshSub();
      });
      tr.querySelector('[data-action="inc"]').addEventListener('click', function() {
        qtyInput.value = parseInt(qtyInput.value || 0) + 1;
        refreshSub();
      });
      qtyInput.addEventListener('change', function() {
        this.value = Math.max(0, parseInt(this.value) || 0);
        refreshSub();
      });
      tr.querySelector('.kz-btn-remove').addEventListener('click', function() {
        cartSet(p, 0);
        tr.remove();
        refreshGrandTotal(productMap);
      });

      tbody.appendChild(tr);
    });

    refreshGrandTotal(productMap);
    initQuoteSubmit(productMap);
    initExportCSV(productMap);
    renderQuoteHistory();
  }

  // ── CSV Export ────────────────────────────────────────────────────────────
  function initExportCSV(productMap) {
    var btn = document.getElementById('kz-export-csv');
    if (!btn) return;

    btn.addEventListener('click', function() {
      var items = cartGet();
      if (items.length === 0) {
        alert(isTR ? 'Dışa aktarılacak ürün yok.' : 'No items to export.');
        return;
      }

      var date = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
      var csvItems = items.map(function(item) {
        var p = productMap[item.product_id];
        if (!p) return null;
        return { p: p, qty: item.qty };
      }).filter(Boolean);
      downloadQuoteCSV(csvItems, date, '');
    });
  }

  // Shared CSV builder
  function downloadQuoteCSV(csvItems, dateStr, quoteId) {
    var sep = ';';
    var headers = [
      isTR ? 'Ürün' : 'Product', 'SKU', isTR ? 'Renk' : 'Color',
      isTR ? 'Koleksiyon' : 'Collection', isTR ? 'Malzeme' : 'Made of',
      isTR ? 'Boyut' : 'Size', isTR ? 'Birim Fiyat' : 'Unit Price',
      'QQ', isTR ? 'Adet' : 'Qty', isTR ? 'Ara Toplam' : 'Subtotal'
    ];

    // Info rows
    var infoRows = [];
    if (quoteId) infoRows.push((isTR ? 'Teklif No' : 'Quote') + sep + quoteId);
    infoRows.push((isTR ? 'Tarih' : 'Date') + sep + dateStr);
    infoRows.push((isTR ? 'Müşteri' : 'Customer') + sep + customerName);
    infoRows.push('');

    var csvRows = infoRows.concat([headers.join(sep)]);
    var grandTotal = 0;

    csvItems.forEach(function(ci) {
      var p = ci.p;
      var wp = parseFloat(wholesalePrice(p) || 0);
      var sub = wp * ci.qty;
      grandTotal += sub;
      var pTitle = isTR ? (p.title_tr || p.title_en) : (p.title_en || p.title_tr);
      var pMat   = isTR ? (p.material || p.material_en || '') : (p.material_en || p.material || '');
      var pCol   = isTR ? (p.collection || '') : mainCat(p.collection || '');
      csvRows.push([
        '"' + pTitle.replace(/"/g, '""') + '"',
        p.sku || '', p.color || '',
        '"' + pCol.replace(/"/g, '""') + '"',
        '"' + pMat.replace(/"/g, '""') + '"',
        '"' + (p.dimensions || '').replace(/"/g, '""') + '"',
        fmtPrice(wp, isEUR),
        (parseInt(p.shopify_stock) || 0) > 0 && ci.qty <= parseInt(p.shopify_stock) ? '□' : '○',
        ci.qty, fmtPrice(sub, isEUR)
      ].join(sep));
    });

    csvRows.push('');
    csvRows.push([
      '', '', '', '', '', '', '',
      isTR ? 'Genel Toplam' : 'Grand Total', '', fmtPrice(grandTotal, isEUR)
    ].join(sep));

    var bom = '\uFEFF';
    var blob = new Blob([bom + csvRows.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    var fileDate = dateStr.replace(/\s/g, '-');
    a.href = url;
    a.download = 'KingZoo_' + (quoteId || 'Quote') + '_' + fileDate + '.csv';
    a.click();
    URL.revokeObjectURL(url);
  }

  // ── Quote ID generation ───────────────────────────────────────────────────
  // Format: Q-YYMMDD-XXXX (e.g. Q-260408-K7X9) — globally unique, date-sortable
  function generateQuoteId() {
    var d = new Date();
    var yy = String(d.getFullYear()).slice(-2);
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // no 0/O/1/I confusion
    var rand = '';
    for (var i = 0; i < 4; i++) rand += chars.charAt(Math.floor(Math.random() * chars.length));
    return 'Q-' + yy + mm + dd + '-' + rand;
  }

  // ── Quote history ─────────────────────────────────────────────────────────
  function saveQuoteToHistory(quoteId, items, productMap, notes) {
    var history = [];
    try { history = JSON.parse(localStorage.getItem(HISTORY_KEY)) || []; } catch(e) {}
    var date = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
    history.unshift({
      id:    quoteId,
      date:  date,
      ts:    Date.now(),
      notes: notes,
      total: formatTotal(items),
      items: items.map(function(item) {
        var p = productMap[item.product_id];
        if (!p) return { title: item.product_id, qty: item.qty, price: '', subtotal: '' };
        return {
          title:       isTR ? (p.title_tr || p.title_en) : (p.title_en || p.title_tr),
          title_tr:    p.title_tr || '',
          title_en:    p.title_en || '',
          sku:         p.sku || '',
          color:       p.color || '',
          collection:  p.collection || '',
          material:    p.material || '',
          material_en: p.material_en || '',
          dimensions:  p.dimensions || '',
          handle:      p.handle || '',
          qty:         item.qty,
          price:       fmtPrice(wholesalePrice(p), isEUR),
          price_raw:   wholesalePrice(p),
          subtotal:    fmtPrice(parseFloat(wholesalePrice(p)) * item.qty, isEUR)
        };
      })
    });
    // Cap history at 30 entries to avoid localStorage overflow
    if (history.length > 30) history = history.slice(0, 30);
    try { localStorage.setItem(HISTORY_KEY, JSON.stringify(history)); } catch(e) {}
  }

  function renderQuoteHistory() {
    var history = [];
    try { history = JSON.parse(localStorage.getItem(HISTORY_KEY)) || []; } catch(e) {}
    if (!history.length) return;
    var page = document.getElementById('kz-myquote-page');
    if (!page) return;

    var wrap = document.createElement('div');
    wrap.id = 'kz-quote-history';
    wrap.style.cssText = 'margin-top:40px;';

    history.forEach(function(q) {
      var sec = document.createElement('div');
      sec.style.cssText = 'border-top:2px solid #eee;padding-top:24px;margin-bottom:32px;';
      var rows = q.items.map(function(i) {
        return '<tr>' +
          '<td style="padding:8px 12px;">' + i.title + '</td>' +
          '<td style="padding:8px 12px;font-family:monospace;font-size:11px;color:#666;">' + (i.sku || '') + '</td>' +
          '<td style="padding:8px 12px;color:#666;">' + (i.color || '') + '</td>' +
          '<td style="padding:8px 12px;color:#666;">' + i.price + '</td>' +
          '<td style="padding:8px 12px;text-align:center;">' + i.qty + '</td>' +
          '<td style="padding:8px 12px;font-weight:600;">' + i.subtotal + '</td>' +
        '</tr>';
      }).join('');
      var thStyle = 'text-align:left;padding:6px 12px;font-size:11px;font-weight:600;color:#999;';
      sec.innerHTML =
        '<div style="display:flex;align-items:center;gap:16px;margin-bottom:14px;">' +
          '<span style="font-size:13px;font-weight:700;letter-spacing:.04em;">' + q.id + '</span>' +
          '<span style="font-size:12px;color:#999;">' + q.date + '</span>' +
          '<a href="#" class="kz-history-csv" data-qidx="' + q.id + '" style="font-size:11px;color:#999;text-decoration:none;border-bottom:1px dotted #ccc;cursor:pointer;margin-left:4px;">' + (isTR ? 'csv ↓' : 'csv ↓') + '</a>' +
          '<span style="margin-left:auto;font-size:13px;font-weight:600;">' + q.total + '</span>' +
        '</div>' +
        '<table style="width:100%;border-collapse:collapse;font-size:13px;">' +
          '<thead><tr style="border-bottom:1px solid #ddd;">' +
            '<th style="' + thStyle + '">' + (isTR ? 'ÜRÜN' : 'PRODUCT') + '</th>' +
            '<th style="' + thStyle + '">SKU</th>' +
            '<th style="' + thStyle + '">' + (isTR ? 'RENK' : 'COLOR') + '</th>' +
            '<th style="' + thStyle + '">' + (isTR ? 'FİYAT' : 'PRICE') + '</th>' +
            '<th style="' + thStyle + 'text-align:center;">' + (isTR ? 'ADET' : 'QTY') + '</th>' +
            '<th style="' + thStyle + '">' + (isTR ? 'TOPLAM' : 'TOTAL') + '</th>' +
          '</tr></thead>' +
          '<tbody>' + rows + '</tbody>' +
        '</table>' +
        (q.notes ? '<p style="margin:10px 12px 0;font-size:12px;color:#888;font-style:italic;">' + q.notes.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;') + '</p>' : '');
      wrap.appendChild(sec);
    });

    page.appendChild(wrap);

    // CSV download for history items
    wrap.addEventListener('click', function(e) {
      var link = e.target.closest('.kz-history-csv');
      if (!link) return;
      e.preventDefault();
      var qid = link.dataset.qidx;
      var hist = [];
      try { hist = JSON.parse(localStorage.getItem(HISTORY_KEY)) || []; } catch(ex) {}
      var q = hist.find(function(h) { return h.id === qid; });
      if (!q || !q.items) return;
      var csvItems = q.items.map(function(i) {
        return {
          p: {
            title_tr: i.title_tr || i.title || '',
            title_en: i.title_en || i.title || '',
            sku: i.sku || '',
            color: i.color || '',
            collection: i.collection || '',
            material: i.material || '',
            material_en: i.material_en || '',
            dimensions: i.dimensions || '',
            wholesale_try: i.price_raw || '',
            wholesale_eur: i.price_raw || ''
          },
          qty: i.qty
        };
      });
      downloadQuoteCSV(csvItems, q.date, q.id);
    });
  }

  function refreshGrandTotal(productMap) {
    var items = cartGet();
    var sum = items.reduce(function(s, i) {
      var p = productMap[i.product_id];
      return s + (p ? parseFloat(wholesalePrice(p) || 0) * i.qty : 0);
    }, 0);
    var el = document.getElementById('kz-grand-total');
    if (el) el.textContent = fmtPrice(sum, isEUR);
  }

  // ── Quote submission ──────────────────────────────────────────────────────
  function initQuoteSubmit(productMap) {
    var btn = document.getElementById('kz-submit-quote');
    var msg = document.getElementById('kz-quote-msg');
    if (!btn) return;

    // Load EmailJS
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
    s.onload = function() { emailjs.init({ publicKey: EMAILJS_PUBLIC_KEY }); };
    document.head.appendChild(s);

    btn.addEventListener('click', function() {
      var items = cartGet();
      if (items.length === 0) {
        if (msg) { msg.style.display = 'block'; msg.style.background = '#fff8e1'; msg.textContent = isTR ? 'Lütfen teklif göndermeden önce ürün ekleyin.' : 'Please add products before sending a quote request.'; }
        return;
      }

      // Rate limiting: max 1 quote per 30 seconds
      var lastSend = parseInt(sessionStorage.getItem('kz_last_quote') || '0');
      if (Date.now() - lastSend < 30000) {
        if (msg) { msg.style.display = 'block'; msg.style.background = '#fff8e1'; msg.textContent = isTR ? 'Lütfen 30 saniye bekleyin.' : 'Please wait 30 seconds before sending again.'; }
        return;
      }

      // Confirmation
      if (!confirm(isTR ? 'Teklif göndermek istediğinize emin misiniz?' : 'Are you sure you want to send this quote request?')) return;

      btn.disabled = true;
      btn.textContent = isTR ? 'Gönderiliyor...' : 'Sending...';

      // Build HTML table for email (full detail — Excel copy-paste ready)
      var hProduct = isTR ? 'Ürün' : 'Product';
      var hSku = 'SKU';
      var hColor = isTR ? 'Renk' : 'Color';
      var hCol = isTR ? 'Koleksiyon' : 'Collection';
      var hMat = isTR ? 'Malzeme' : 'Made of';
      var hSize = isTR ? 'Boyut' : 'Size';
      var hPrice = isTR ? 'Birim Fiyat' : 'Unit Price';
      var hStock = 'QQ';
      var hQty = isTR ? 'Adet' : 'Qty';
      var hSub = isTR ? 'Ara Toplam' : 'Subtotal';

      // Siyah-beyaz: beyaz zemin, siyah yazı, açık gri çerçeve
      var cellStyle = 'border:1px solid #cccccc;padding:8px 10px;color:#000000;';
      var thStyle   = cellStyle + 'background:#ffffff;font-weight:bold;text-align:left;';

      var rows = items.map(function(item) {
        var p = productMap[item.product_id];
        if (!p) return '';
        var wp = wholesalePrice(p);
        var sub = fmtPrice(parseFloat(wp) * item.qty, isEUR);
        var pTitle = isTR ? (p.title_tr || p.title_en) : (p.title_en || p.title_tr);
        var pMat   = isTR ? (p.material || p.material_en || '') : (p.material_en || p.material || '');
        var pCol   = mainCat(p.collection || '');
        var pColTR = { 'Tableware': 'Sofra', 'Home Decor': 'Ev Dekorasyonu', 'Bathroom': 'Banyo' };
        var pColDisplay = isTR ? (pColTR[pCol] || pCol) : pCol;
        var pStock = parseInt(p.shopify_stock) || 0;
        var stockOk = pStock > 0 && item.qty <= pStock;
        var stockSym = stockOk ? '□' : '○';
        return '<tr>' +
          '<td style="' + cellStyle + '">' + pTitle + '</td>' +
          '<td style="' + cellStyle + '">' + (p.sku || '') + '</td>' +
          '<td style="' + cellStyle + '">' + (p.color || '') + '</td>' +
          '<td style="' + cellStyle + '">' + pColDisplay + '</td>' +
          '<td style="' + cellStyle + '">' + pMat + '</td>' +
          '<td style="' + cellStyle + '">' + (p.dimensions || '') + '</td>' +
          '<td style="' + cellStyle + '">' + fmtPrice(wp, isEUR) + '</td>' +
          '<td style="' + cellStyle + 'text-align:center;font-weight:600;">' + stockSym + '</td>' +
          '<td style="' + cellStyle + 'text-align:center;">' + item.qty + '</td>' +
          '<td style="' + cellStyle + '">' + sub + '</td></tr>';
      }).join('');

      var orderItems =
        '<table cellpadding="0" cellspacing="0" style="border-collapse:collapse;font-size:13px;width:100%;background:#ffffff;">' +
        '<thead><tr>' +
          '<th style="' + thStyle + '">' + hProduct + '</th>' +
          '<th style="' + thStyle + '">' + hSku + '</th>' +
          '<th style="' + thStyle + '">' + hColor + '</th>' +
          '<th style="' + thStyle + '">' + hCol + '</th>' +
          '<th style="' + thStyle + '">' + hMat + '</th>' +
          '<th style="' + thStyle + '">' + hSize + '</th>' +
          '<th style="' + thStyle + '">' + hPrice + '</th>' +
          '<th style="' + thStyle + 'text-align:center;">' + hStock + '</th>' +
          '<th style="' + thStyle + 'text-align:center;">' + hQty + '</th>' +
          '<th style="' + thStyle + '">' + hSub + '</th>' +
        '</tr></thead>' +
        '<tbody>' + rows + '</tbody></table>';

      var total = items.reduce(function(s, i) {
        var p = productMap[i.product_id];
        return s + (p ? parseFloat(wholesalePrice(p) || 0) * i.qty : 0);
      }, 0);

      var notes = (document.getElementById('kz-order-notes') || {}).value || '';
      var date  = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
      var quoteId = generateQuoteId();

      // Structured payload for server-side ingestion (Python script reads from Gmail).
      // Embedded in the email body inside a hidden <div id="kz-quote-json">…</div>.
      var quotePayload = {
        quote_id:       quoteId,
        customer_email: customerEmail,
        customer_name:  customerName,
        submit_date:    new Date().toISOString(),
        currency:       isEUR ? 'EUR' : 'TRY',
        total:          Number(total.toFixed(2)),
        item_count:     items.reduce(function(s, i) { return s + (parseInt(i.qty) || 0); }, 0),
        notes:          notes,
        status:         'new',
        items: items.map(function(item) {
          var p = productMap[item.product_id] || {};
          return {
            product_id: item.product_id,
            sku:        p.sku || '',
            title_tr:   p.title_tr || '',
            title_en:   p.title_en || '',
            color:      p.color || '',
            collection: p.collection || '',
            qty:        parseInt(item.qty) || 0,
            unit_price: Number(parseFloat(wholesalePrice(p) || 0).toFixed(2))
          };
        })
      };
      var quoteJson = JSON.stringify(quotePayload);

      // Dil bazlı email metinleri — müşteri etiketine göre (B2BTR → TR, B2BEXP → EN)
      var greeting     = isEmailTR ? ('Sayın ' + customerName + ',') : ('Dear Mr./Mrs. ' + customerName + ',');
      var introText    = isEmailTR
        ? 'Teklif talebiniz tarafımıza ulaşmıştır. Aşağıda ilettiğiniz ürünlerin detaylarını bulabilirsiniz. Ekibimiz en kısa sürede stok durumu, sevkiyat detayları ve nihai teklif ile size dönüş yapacaktır.'
        : 'Your quote request has been received. Below you will find the details of the products you submitted. Our team will get back to you shortly with stock availability, shipping details and the final offer.';
      var notesLabel   = isEmailTR ? 'Talepler' : 'Requests';
      var totalLabel   = isEmailTR ? 'Genel Toplam' : 'Grand Total';
      var refLabel     = isEmailTR ? 'Teklif Numarası' : 'Quote Reference';
      var dateLabel    = isEmailTR ? 'Tarih' : 'Date';
      var companyLabel = isEmailTR ? 'Firma' : 'Company';
      var nameLabel    = isEmailTR ? 'Ad Soyad' : 'Name';
      var emailLabel   = isEmailTR ? 'E-posta' : 'Email';
      var itemsLabel   = isEmailTR ? 'Talep Edilen Ürünler' : 'Requested Items';
      var detailsLabel = isEmailTR ? 'Müşteri Bilgileri' : 'Customer Details';
      var closingText  = isEmailTR
        ? 'Herhangi bir sorunuz olursa bu e-postaya yanıtlamanız ya da hey@kingzoo.co adresinden bize ulaşmanız yeterlidir.'
        : 'If you have any questions, simply reply to this email or reach us at hey@kingzoo.co.';
      var signature    = isEmailTR ? 'Saygılarımızla,<br>KingZoo Ekibi' : 'Best regards,<br>The KingZoo Team';
      var emailTitle   = isEmailTR ? 'Teklif Talebi' : 'Quote Request';

      emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TPL_QUOTE, {
        quote_id:       quoteId,
        company_name:   customerName,
        customer_name:  customerName,
        customer_email: customerEmail,
        submit_date:    date,
        order_items:    orderItems,
        order_total:    fmtPrice(total, isEUR),
        order_notes:    notes,
        quote_json:     quoteJson,
        // Dil bazlı metinler (template'de doğrudan kullanılır)
        greeting:       greeting,
        intro_text:     introText,
        notes_label:    notesLabel,
        total_label:    totalLabel,
        ref_label:      refLabel,
        date_label:     dateLabel,
        company_label:  companyLabel,
        name_label:     nameLabel,
        email_label:    emailLabel,
        items_label:    itemsLabel,
        details_label:  detailsLabel,
        closing_text:   closingText,
        signature:      signature,
        email_title:    emailTitle,
        is_tr:          isEmailTR ? '1' : ''
      })
      .then(function() {
        sessionStorage.setItem('kz_last_quote', String(Date.now()));
        saveQuoteToHistory(quoteId, items, productMap, notes);
        cartSave([]); // clear active cart
        // Reload page so history renders fresh and cart resets
        window.location.reload();
      })
      .catch(function(err) {
        console.error('EmailJS error', err);
        btn.disabled = false;
        btn.textContent = isTR ? 'Teklif Gönder' : 'Send Quote Request';
        msg.style.display = 'block';
        msg.style.background = '#fff0f0';
        msg.textContent = isTR ? 'Bir hata oluştu. Lütfen hey@kingzoo.co adresine e-posta gönderin.' : 'Something went wrong. Please email us at hey@kingzoo.co';
      });
    });
  }

  // ── Styles ────────────────────────────────────────────────────────────────
  function injectStyles() {
    var css = `
      /* Page containers — match theme page-width */
      #kz-order-form-page,
      #kz-quickquote-page,
      #kz-myquote-page {
        max-width: 1280px;
        margin: 0 auto;
        padding: 0 40px;
        box-sizing: border-box;
      }
      @media (max-width: 768px) {
        #kz-order-form-page,
        #kz-quickquote-page,
        #kz-myquote-page { padding: 0 16px; }
      }

      /* Wholesale global */
      .kz-wh-header { padding: 32px 0 16px; }
      .kz-wh-header h1 { font-size: 22px; font-weight: 600; margin: 0; }

      .kz-toolbar { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-bottom: 16px; }
      #kz-search { padding: 9px 14px; border: 1px solid #ddd; border-radius: 6px; font-size: 13px; width: 220px; height: 38px; box-sizing: border-box; }
      .kz-filters { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
      .kz-filter-btn { padding: 0 14px; border: 1px solid #ddd; border-radius: 6px; background: #fff; font-size: 13px; cursor: pointer; text-transform: none !important; height: 38px; line-height: 36px; }
      .kz-filter-btn.active { background: #000; color: #fff; border-color: #000; }
      #kz-color-filter { height: 38px; padding: 0 12px; border: 1px solid #ddd; border-radius: 6px; font-size: 13px; background: #fff; cursor: pointer; }
      #kz-reset-filters { border: none !important; background: none !important; color: #888; font-size: 13px; font-style: normal; text-decoration: underline; cursor: pointer; height: 38px; padding: 0 8px; }
      #kz-reset-filters:hover { color: #333; }

      .kz-table-wrap { overflow-x: auto; margin-bottom: 24px; -webkit-overflow-scrolling: touch; }
      .kz-table { width: 100%; border-collapse: collapse; font-size: 13px; }
      .kz-table th { text-align: left; padding: 10px 12px; border-bottom: 2px solid #000; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .04em; white-space: nowrap; color: #555; }
      .kz-table td { padding: 10px 12px; border-bottom: 1px solid #f0f0f0; vertical-align: middle; }
      .kz-table tbody tr:hover { background: #fafaf8; }

      .kz-prod-img { width: 56px; height: 56px; object-fit: cover; border-radius: 8px; display: block; box-shadow: 0 1px 3px rgba(0,0,0,.08); }
      .kz-td-img { width: 68px; padding-right: 4px !important; }
      .kz-td-product a { color: inherit; text-decoration: none; font-weight: 600; font-size: 13px; }
      .kz-td-product a:hover { text-decoration: underline; }
      .kz-td-sku { font-size: 11px; color: #999; font-family: monospace; }
      .kz-td-color { font-size: 12px; color: #666; }
      .kz-td-col { font-size: 12px; }
      .kz-td-mat { font-size: 12px; color: #666; }
      .kz-td-size { font-size: 12px; color: #666; }
      .kz-td-retail { color: #999; font-size: 12px; }
      .kz-td-ws { font-weight: 600; font-size: 13px; }
      .kz-td-disc { color: #c00; font-size: 11px; font-weight: 500; }
      .kz-mobile-stock { display: none; font-size: 10px; font-weight: 600; }

      .kz-qty-wrap { display: inline-flex; align-items: center; border: 1px solid #e0e0e0; border-radius: 4px; overflow: hidden; }
      .kz-qty-btn { width: 20px; height: 20px; border: none; background: transparent; cursor: pointer; font-size: 10px; color: #888; display: flex; align-items: center; justify-content: center; transition: color .15s; padding: 0; }
      .kz-qty-btn:hover { color: #000; }
      .kz-qty-input { width: 26px; height: 20px; text-align: center; border: none; border-left: 1px solid #eee; border-right: 1px solid #eee; font-size: 11px; background: #fff; -moz-appearance: textfield; padding: 0; }
      .kz-qty-input::-webkit-outer-spin-button,
      .kz-qty-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }

      .kz-row-btn { padding: 5px 10px; border: none; cursor: pointer; font-size: 12px; }
      .kz-btn-add { background: #000; color: #fff; }
      .kz-btn-add:hover { background: #333; }
      .kz-btn-remove { background: transparent; color: #999; font-size: 18px; line-height: 1; }
      .kz-btn-remove:hover { color: #c00; }

      .kz-btn-primary { display: inline-block; padding: 11px 24px; background: #000; color: #fff; text-decoration: none; font-size: 13px; border: none; cursor: pointer; letter-spacing: .04em; }
      .kz-btn-primary:hover { background: #333; color: #fff; }
      .kz-btn-secondary { display: inline-block; padding: 11px 24px; background: transparent; color: #000; text-decoration: none; font-size: 13px; border: 1px solid #000; cursor: pointer; }

      /* Mini cart bar */
      #kz-mini-cart { position: fixed; bottom: 0; left: 0; right: 0; background: #000; color: #fff; z-index: 9999; padding: 12px 24px; }
      #kz-mini-cart-inner { display: flex; align-items: center; gap: 16px; max-width: 1200px; margin: 0 auto; }
      #kz-mini-count { font-size: 13px; flex: 1; }
      #kz-mini-total { font-size: 15px; font-weight: 600; }
      #kz-mini-cart .kz-btn-primary { background: #fff; color: #000; }
      #kz-mini-cart .kz-btn-primary:hover { background: #eee; }

      /* My Quote notes */
      .kz-notes-section { max-width: 600px; margin-bottom: 24px; }
      .kz-quote-actions { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }

      /* ── Desktop responsive — progressive column hiding ─────────── */
      @media (max-width: 1100px) {
        .kz-td-size, .kz-table th:nth-child(7),
        .kz-td-disc, .kz-table th:nth-child(10) { display: none; }
      }
      @media (max-width: 960px) {
        .kz-td-sku, .kz-table th:nth-child(3),
        .kz-td-mat, .kz-table th:nth-child(6) { display: none; }
      }

      /* ── Mobile: QQ card layout ────────────────────────────────── */
      @media (max-width: 768px) {
        /* Search full-width */
        .kz-toolbar { flex-direction: column; align-items: stretch; }
        #kz-search { width: 100%; }

        /* Filter rows: horizontal scroll (Order Form) */
        .kz-filters { overflow-x: auto; -webkit-overflow-scrolling: touch; flex-wrap: nowrap; padding-bottom: 4px; gap: 6px; }
        .kz-filter-row { flex-wrap: nowrap !important; overflow-x: auto; -webkit-overflow-scrolling: touch; padding-bottom: 2px; }
        .kz-filter-btn { white-space: nowrap; flex-shrink: 0; font-size: 12px; padding: 0 10px; height: 34px; line-height: 32px; }

        /* Quick Quote: vertical accordion — only main category visible, subs collapse under it */
        #kz-quickquote-page .kz-filters { flex-direction: column; align-items: stretch; flex-wrap: nowrap; overflow: visible !important; gap: 4px; padding-bottom: 0; }
        #kz-quickquote-page .kz-filters > .kz-filter-btn { width: 100%; text-align: center; }
        #kz-quickquote-page .kz-filter-row { flex-wrap: wrap !important; overflow: visible !important; gap: 4px; padding-bottom: 0; }
        #kz-quickquote-page .kz-filter-row .kz-filter-btn:not(.kz-filter-main) { display: none; }
        #kz-quickquote-page .kz-filter-row.expanded .kz-filter-btn:not(.kz-filter-main) { display: inline-block; }
        #kz-quickquote-page .kz-filter-main { width: 100%; text-align: left; padding-left: 14px !important; padding-right: 32px !important; position: relative; }
        #kz-quickquote-page .kz-filter-main::after { content: '▾'; position: absolute; right: 12px; top: 50%; transform: translateY(-50%); font-size: 11px; opacity: .7; }
        #kz-quickquote-page .kz-filter-row.expanded .kz-filter-main::after { content: '▴'; }

        /* Hide table header */
        #kz-quickquote-page .kz-table thead { display: none; }
        #kz-quickquote-page .kz-table,
        #kz-quickquote-page .kz-table tbody { display: block; width: 100%; }

        /* Each row → card */
        #kz-quickquote-page .kz-table tbody tr[data-pid] {
          display: grid !important;
          grid-template-columns: 56px 1fr auto;
          grid-template-rows: auto auto auto;
          gap: 2px 10px;
          padding: 12px 0;
          border-bottom: 1px solid #eee;
          align-items: center;
        }

        /* Row 1: img | product name | wholesale price */
        #kz-quickquote-page .kz-td-img     { grid-row: 1/3; grid-column: 1; padding: 0 !important; }
        #kz-quickquote-page .kz-td-product  { grid-row: 1; grid-column: 2; padding: 2px 0 !important; }
        #kz-quickquote-page .kz-td-product a { font-size: 13px; }
        #kz-quickquote-page .kz-td-ws      { grid-row: 1; grid-column: 3; padding: 2px 0 !important; text-align: right; font-size: 14px; }

        /* Row 2: _ | color · stock | qty */
        #kz-quickquote-page .kz-td-color   { grid-row: 2; grid-column: 2; padding: 0 !important; font-size: 11px; color: #888; }
        #kz-quickquote-page .kz-td-stock   { display: none; }
        #kz-quickquote-page .kz-td-qty     { grid-row: 2; grid-column: 3; padding: 0 !important; justify-self: end; }

        /* Row 3: subtotal spanning right side */
        #kz-quickquote-page .kz-subtotal-cell { grid-row: 3; grid-column: 2/4; padding: 4px 0 0 !important; text-align: right; font-size: 12px; font-weight: 600; color: #333; }

        /* Hidden on mobile cards */
        #kz-quickquote-page .kz-td-sku,
        #kz-quickquote-page .kz-td-col,
        #kz-quickquote-page .kz-td-mat,
        #kz-quickquote-page .kz-td-size { display: none !important; }

        /* Show stock badge inline with color on mobile */
        #kz-quickquote-page .kz-mobile-stock { display: inline; }

        /* Separator row */
        #kz-quickquote-page .kz-table tbody tr:not([data-pid]) {
          display: block !important;
        }
        #kz-quickquote-page .kz-table tbody tr:not([data-pid]) td {
          display: block; padding: 8px 0 !important; font-size: 11px;
        }

        /* Card image */
        #kz-quickquote-page .kz-prod-img { width: 52px; height: 52px; border-radius: 6px; }

        /* Qty controls slightly bigger for touch */
        #kz-quickquote-page .kz-qty-btn { width: 28px; height: 28px; font-size: 14px; }
        #kz-quickquote-page .kz-qty-input { width: 34px; height: 28px; font-size: 13px; }

        /* Mini cart bar */
        #kz-mini-cart { padding: 10px 12px; }
        #kz-mini-cart-inner { gap: 10px; flex-wrap: wrap; }
        #kz-mini-count { font-size: 12px; flex: 1 1 auto; }
        #kz-mini-total { font-size: 14px; }
        #kz-mini-cart .kz-btn-primary { padding: 9px 16px; font-size: 12px; }

        /* Order Form & My Quote: keep table but slim */
        #kz-order-form-page .kz-td-col, #kz-order-form-page .kz-table th:nth-child(5),
        #kz-order-form-page .kz-td-retail, #kz-order-form-page .kz-table th:nth-child(8) { display: none; }
        .kz-table td, .kz-table th { padding: 8px 6px; }
        .kz-prod-img { width: 48px; height: 48px; border-radius: 6px; }
        .kz-td-img { width: 56px; }
        .kz-td-product a { font-size: 12px; }
        .kz-td-color { font-size: 11px; }
      }

      /* ── Extra small screens ───────────────────────────────────── */
      @media (max-width: 400px) {
        #kz-quickquote-page .kz-table tbody tr[data-pid] {
          grid-template-columns: 44px 1fr auto;
          gap: 2px 8px;
          padding: 10px 0;
        }
        #kz-quickquote-page .kz-prod-img { width: 44px; height: 44px; }
        #kz-quickquote-page .kz-td-product a { font-size: 12px; }
        #kz-quickquote-page .kz-td-ws { font-size: 13px; }
        #kz-quickquote-page .kz-qty-btn { width: 26px; height: 26px; font-size: 13px; }
        #kz-quickquote-page .kz-qty-input { width: 30px; height: 26px; font-size: 12px; }

        #kz-mini-cart-inner { justify-content: space-between; }
        #kz-mini-count { font-size: 11px; }
      }
    `;
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ── Master product loader: Shopify /products.json + CSV join ──────────────
  // Master kaynak Shopify'dır → yeni ürün eklenince Order Form'a OTOMATİK düşer.
  // CSV (metafield) sadece fiyat + Türkçe meta + alt-kategori için join edilir.
  // Eşleşme: SKU bazlı (her Shopify variant.sku ↔ CSV.sku).
  // Stok adedi: window.kzCustomer.stockMap (server-side, Admin API'den) — storefront
  // /products.json inventory_quantity'i Shopify policy gereği 0 dönüyor, bu yüzden
  // gerçek qty için ayrı metafield (shop.custom.wholesale_stock_data) kullanılır.
  function loadAllProducts(cb) {
    loadCSV(function(csvData) {
      var bySku = {};
      (csvData || []).forEach(function(c) {
        var sku = (c && c.sku || '').trim();
        if (sku) bySku[sku] = c;
      });

      var serverStock = (window.kzCustomer && window.kzCustomer.stockMap) || {};

      fetch('/products.json?limit=250')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = (data.products || []).map(function(sp) {
            var firstVariant = (sp.variants && sp.variants[0]) || {};
            var sku = (firstVariant.sku || '').trim();
            var csvRow = bySku[sku] || {};
            var anyAvailable = (sp.variants || []).some(function(v) { return v.available; });
            // Gerçek qty server stockMap'ten — storefront totalQty güvenilmez (her zaman 0)
            var realQty = parseInt(serverStock[sp.handle]) || 0;

            return {
              // Always from Shopify (master)
              product_id:        'gid://shopify/Product/' + sp.id,
              handle:            sp.handle,
              sku:               sku,
              shopify_available: anyAvailable,
              shopify_stock:     realQty, // server-side metafield (Yengeç → Admin API → Shop metafield)

              // Title (CSV TR + EN if present, else Shopify default)
              title_tr:    csvRow.title_tr || sp.title || '',
              title_en:    csvRow.title_en || sp.title || '',

              // Image (CSV override; fallback Shopify primary image)
              image_url:   csvRow.image_url
                          || (sp.images && sp.images[0] && sp.images[0].src)
                          || (sp.image && sp.image.src)
                          || '',

              // Pricing — CSV-only. Yeni ürünler CSV'de yoksa boş kalır → "—" gösterilir
              retail_try:    csvRow.retail_try || '',
              retail_eur:    csvRow.retail_eur || '',
              wholesale_try: csvRow.wholesale_try || '',
              wholesale_eur: csvRow.wholesale_eur || '',

              // Meta (CSV + Shopify product_type fallback)
              collection:  csvRow.collection || sp.product_type || '',
              color:       csvRow.color || '',
              material:    csvRow.material || '',
              material_en: csvRow.material_en || '',
              dimensions:  csvRow.dimensions || '',

              // Flags
              has_csv:     !!csvRow.sku,
              shopify_only: !csvRow.sku
            };
          });
          cb(products);
        })
        .catch(function() {
          // Fallback: Shopify fetch fail → CSV-only render (mevcut davranış)
          cb(csvData || []);
        });
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    injectStyles();

    var pageId = null;
    if (document.getElementById('kz-order-form-page'))  pageId = 'form';
    if (document.getElementById('kz-quickquote-page'))  pageId = 'quickquote';
    if (document.getElementById('kz-myquote-page'))     pageId = 'myquote';

    if (!pageId) return;

    // Tüm sayfalar → Shopify-driven (loadAllProducts) kullanır.
    // My Quote da shopify_stock'a ihtiyaç duyar (QQ kolonundaki ■/○ kararı için).
    loadAllProducts(function(products) {
      if (pageId === 'form')       initOrderForm(products);
      if (pageId === 'quickquote') initQuickQuote(products);
      if (pageId === 'myquote')    initMyQuote(products);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
